import { action } from 'typesafe-actions';
import { TransactionTypes, TransactionLogDto } from './types';
import { Currency, DataStream, Transaction, TransactionHistory, TransactionReason } from '../../interfaces';

export const getTransactionsRequest = (payload: any) =>
  action(TransactionTypes.GET_TRANSACTIONS_REQUEST, payload);

export const getTransactionsSuccess = (data: TransactionHistory) =>
  action(TransactionTypes.GET_TRANSACTIONS_SUCCESS, data);

export const getTransactionsFailure = (error: any) =>
  action(TransactionTypes.GET_TRANSACTIONS_FAILURE, error);

export const viewTransactionsOverviewRequest = (payload: any) =>
  action(TransactionTypes.VIEW_TRANSACTIONS_OVERVIEW_REQUEST, payload);

export const viewTransactionsOverviewSuccess = (data: Transaction) =>
  action(TransactionTypes.VIEW_TRANSACTIONS_OVERVIEW_SUCCESS, data);

export const viewTransactionsOverviewFailure = (error: any) =>
  action(TransactionTypes.VIEW_TRANSACTIONS_OVERVIEW_FAILURE, error);

export const getCurrencies = () => action(TransactionTypes.GET_CURRENCIES);

export const getCurrenciesSuccess = (data: Currency[]) =>
  action(TransactionTypes.GET_CURRENCIES_SUCCESS, data);

export const getCurrenciesFailure = (error: any) =>
  action(TransactionTypes.GET_CURRENCIES_FAILURE, error);

export const exportTranxRequest = (payload: any) =>
  action(TransactionTypes.EXPORT_TRANSACTIONS_REQUEST, payload);

export const exportTranxSuccess = (data: DataStream) =>
  action(TransactionTypes.EXPORT_TRANSACTIONS_SUCCESS, data);

export const exportTranxFailure = (error: any) =>
  action(TransactionTypes.EXPORT_TRANSACTIONS_FAILURE, error);

export const exportViewTransactionsOverviewRequest = (payload: any) =>
  action(TransactionTypes.EXPORT_VIEW_TRANSACTIONS_OVERVIEW_REQUEST, payload);

export const exportViewTransactionsOverviewSuccess = (data: DataStream) =>
  action(TransactionTypes.EXPORT_VIEW_TRANSACTIONS_OVERVIEW_SUCCESS, data);

export const exportViewTransactionsOverviewFailure = (error: any) =>
  action(TransactionTypes.EXPORT_VIEW_TRANSACTIONS_OVERVIEW_FAILURE, error);

export const downloadReceiptRequest = (transactionId: number) =>
  action(TransactionTypes.DOWNLOAD_RECEIPT_REQUEST, transactionId);

export const downloadReceiptSuccess = (data: DataStream) =>
  action(TransactionTypes.DOWNLOAD_RECEIPT_SUCCESS, data);

export const downloadReceiptFailure = (error: any) =>
  action(TransactionTypes.DOWNLOAD_RECEIPT_FAILURE, error);

export const getTransactionReason = (transactionId: number) =>
  action(TransactionTypes.GET_TRANSACTION_REASONS, transactionId);

export const getTransactionReasonsSuccess = (data: TransactionReason[]) =>
  action(TransactionTypes.GET_TRANSACTION_REASONS_SUCCESS, data);

export const getTransactionReasonsFailure = (error: any) =>
  action(TransactionTypes.GET_TRANSACTION_REASONS_FAILURE, error);

export const getTransactionLogsRequest = (transactionId: string) =>
  action(TransactionTypes.GET_TRANSACTION_LOGS_REQUEST, transactionId);

export const getTransactionLogsSuccess = (data: TransactionLogDto[]) =>
  action(TransactionTypes.GET_TRANSACTION_LOGS_SUCCESS, data);

export const getTransactionLogsFailure = (error: any) =>
  action(TransactionTypes.GET_TRANSACTION_LOGS_FAILURE, error);
